<template>
  <yxtf-dialog
    :title="$t('pc_biz_ai_feedback_title').d('我要反馈')"
    :visible.sync="visible"
    :append-to-body="true">
    <div v-if="settings.fastFeedbackList && settings.fastFeedbackList.length" class="mb16">
      <yxtf-tag v-for="(tag, index) in settings.fastFeedbackList" :key="index" type="info" class="hand" @click="tagClicked(tag)">{{ tag }}</yxtf-tag>
    </div>
    <yxtf-input
      v-model="value"
      type="textarea"
      :placeholder="$t('pc_biz_ai_input_feedback_conent').d('请输入反馈内容')"
      rows="4"
      resize="none"
      autofocus
      :maxlength="maxlength"
      show-word-limit
    ></yxtf-input>
    <span slot="footer" class="dialog-footer">
      <yxtf-button @click="visible = false">{{ $t('pc_biz_ai_btn_cancel').d('取消') }}</yxtf-button>
      <yxtf-button type="primary" @click="save">{{ $t('pc_biz_ai_btn_submit').d('提交') }}</yxtf-button>
    </span>
  </yxtf-dialog>
</template>

<script>
import { submitQuestionFeedback } from '../service';
export default {
  name: 'FeedbackDialog',
  inject: ['settings'],
  data() {
    return {
      visible: false,
      maxlength: 200,
      value: ''
    };
  },
  methods: {
    toSubmit(msg) {
      this.msg = msg;
      this.value = '';
      this.visible = true;
    },
    tagClicked(val) {
      const text = this.value ? `${this.value}，${val}` : val;
      if (text && text.length > this.maxlength) {
        return;
      }
      this.value = text;
    },
    save() {
      if (!this.value) {
        this.$message.error(this.$t('pc_biz_ai_feedback_not_empty').d('反馈内容不能为空！'));
        return;
      }
      submitQuestionFeedback({
        chatContentId: this.msg.chatContentId,
        correctContent: this.value
      }).then(() => {
        this.$message.success(
          this.$t('pc_biz_ai_feedback_success').d('感谢您的反馈！')
        );
        this.msg.chatCorrectEnabled = 1; // 更新反馈状态
        this.visible = false;
      });

    }
  }
};
</script>
